import groupsApp from '../applications/groups_application'
import groupEditApp from '../applications/groups_edit_application'
import tutorialsApp from '../applications/tutorials_app'
import inboxApp from '../applications/inbox_app'
import competitionsApp from '../applications/competitions_app'
import communityReportApp from '../applications/community_report_app'
import engineersEdit from '../applications/engineers_edit'
import engineersApp from '../applications/engineers_view'
import styleguideApp from '../applications/styleguide_app'
import opentoworkApp from '../applications/opentowork_app'
import communityadsApp from '../applications/communityads_app'
import shopApp from '../applications/shop_app'
import grabcadApp from '../application'
import tutorialEditorApp from '../applications/tutorial_editor_app'

const applicationMap = {
    groupsApp,
    grabcadApp,
    groupEditApp,
    communityReportApp,
    tutorialsApp,
    inboxApp,
    competitionsApp,
    engineersEdit,
    engineersApp,
    styleguideApp,
    opentoworkApp,
    communityadsApp,
    shopApp,
    tutorialEditorApp,
    dashboardApp: {},
    questionApp: {},
    questionEditApp: {}
}

export default (appIdentifier) => applicationMap[appIdentifier]
